/**
 * Environment tokens Entra group names carry directly after the group type, e.g.
 * `K12-Households-Dev-CARLOSGARCIALOPEZ-2000003`. Mirrors the environment segment added by the API's
 * group naming.
 */
const ENVIRONMENT_SEGMENTS = [
  'local',
  'dev',
  'development',
  'test',
  'testing',
  'qa',
  'stage',
  'staging',
  'preprod',
  'prod',
  'production'
];

const ENVIRONMENT_PREFIX = new RegExp(
  `^(K12-(?:Households|Providers|Schools|Institutions))-(?:${ENVIRONMENT_SEGMENTS.join('|')})-`,
  'i'
);

/**
 * Strips the environment segment from an Entra group name so the rest of the app can keep comparing
 * against the environment-neutral names (`K12-Providers-Generic`, `K12-admin-Global-admin`, ...).
 * Names without an environment segment are returned unchanged.
 */
export function normalizeEntraGroupName(name: string): string {
  return name.replace(ENVIRONMENT_PREFIX, '$1-');
}

export function normalizeEntraGroupNames(names: readonly string[] | null | undefined): string[] {
  return (names ?? []).map(normalizeEntraGroupName);
}
